import React from 'react';
import { WaitingState } from '../types';
import './BottomBar.css';

interface BottomBarProps {
  state: WaitingState;
  progressPercent: number;
  elapsedSeconds: number;
  estimatedDuration: number;
  onContinueClick: () => void;
}

export const BottomBar: React.FC<BottomBarProps> = ({
  state,
  progressPercent,
  elapsedSeconds,
  estimatedDuration,
  onContinueClick
}) => {
  const isDisabled = state === 'GENERATING';
  const isGlowing = state === 'FINALIZING';
  const remainingSeconds = Math.max(0, estimatedDuration - elapsedSeconds);

  const getButtonText = (): string => {
    switch (state) {
      case 'GENERATING':
        return 'Hazırlanıyor...';
      case 'READY':
        return 'Devam Et';
      case 'FINALIZING':
        return 'Devam Et';
      case 'COMPLETED':
        return 'Sonucu Gör';
      default:
        return 'Devam Et';
    }
  };

  const getStatusText = (): string => {
    switch (state) {
      case 'GENERATING':
        return `Tahmini ${remainingSeconds} saniye kaldı`;
      case 'READY':
        return 'Hazır! Devam edebilirsiniz';
      case 'FINALIZING':
        return 'Sonucunuz hazır!';
      case 'COMPLETED':
        return 'Tamamlandı';
      default:
        return '';
    }
  };

  const getProgressMessage = (): string => {
    if (state === 'READY' || state === 'FINALIZING' || state === 'COMPLETED') {
      return 'İşlem tamamlandı!';
    }
    
    if (progressPercent < 20) return 'Kombin oluşturuluyor...';
    if (progressPercent < 40) return 'Renk düzenlemeleri yapılıyor...';
    if (progressPercent < 60) return 'Işık ayarları optimize ediliyor...';
    if (progressPercent < 80) return 'Son dokunuşlar yapılıyor...';
    return 'Hazırlanıyor...';
  };

  return (
    <div className="waiting-bottom-bar">
      <div className="waiting-bottom-bar__progress-container">
        <div className="waiting-bottom-bar__progress-info">
          <span className="waiting-bottom-bar__status-text">{getStatusText()}</span>
          <span className="waiting-bottom-bar__progress-message">{getProgressMessage()}</span>
        </div>
        <div className="waiting-bottom-bar__progress-track">
          <div
            className={`waiting-bottom-bar__progress-fill ${
              state === 'READY' || state === 'FINALIZING' ? 'complete' : ''
            }`}
            style={{ width: `${Math.min(progressPercent, 100)}%` }}
          />
        </div>
      </div>

      <div className={`waiting-bottom-bar__button-wrapper ${isGlowing ? 'active' : ''}`}>
        {isGlowing && (
          <div className="waiting-bottom-bar__particles">
            {[...Array(12)].map((_, i) => (
              <div key={i} className="waiting-bottom-bar__particle" style={{ '--i': i } as React.CSSProperties} />
            ))}
          </div>
        )}
        <button
          className={`waiting-bottom-bar__continue-btn ${
            isDisabled ? 'disabled' : ''
          } ${isGlowing ? 'glowing' : ''}`}
          onClick={onContinueClick}
          disabled={isDisabled}
        >
          <span className="waiting-bottom-bar__btn-text">{getButtonText()}</span>
          {!isDisabled && (
            <svg
              className="waiting-bottom-bar__btn-icon"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};

export default BottomBar;
